import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import AddressControl from 'components/AddressControl';
import ButtonControl from 'components/ButtonControl';
import { translate as t } from 'lang';
import AnimakitExpander from 'animakit-expander';

import './Waypoint.scss';

class Waypoint extends Component {

	static propTypes = {
		addresses: PropTypes.array.isRequired,
		onChange: PropTypes.func,
		showAdditionalAddress: PropTypes.bool,
		onMainMapSave: PropTypes.func,
		onAdditionalMapSave: PropTypes.func,
		presetLocation: PropTypes.bool,
		highlightMainInput: PropTypes.bool,
        defaultCountry: PropTypes.number,
		errorMessage: PropTypes.string,
	}

	static defaultProps = {
		showAdditionalAddress: false,
		presetLocation: false,
	}

	state = {
		showAdditionalAddress: this.props.showAdditionalAddress,
		showAddNewAddressButton: this.props.addresses[0] && Object.keys(this.props.addresses[0]).length > 0,
	}

	_onAddressChange = (order = 0, transformedLocation = null) => {
		const { addresses } = this.props;
		addresses[order] = transformedLocation;
		if (this.props.onChange) {
 			this.props.onChange(addresses);
		}
	}

	_onAddressBlur = () => {
		this.setState({
			showAddNewAddressButton: true,
		});
	}

	_addAdditionalAddress = () => {
		this.setState({
			showAdditionalAddress: true
		});
	}

	_removeAdditionalAddress = () => {
		var { addresses } = this.props;
		addresses[1] = undefined;
		this.setState({
			showAdditionalAddress: false
		});

		if (this.props.onChange) {
			this.props.onChange(addresses);
		}
	}

	render() {
		const { addresses } = this.props
		const { showAdditionalAddress, showAddNewAddressButton } = this.state

        const buttonClassNames = classnames([
			'Waypoint-button',
			{
				'-hidden': showAdditionalAddress
			}
		])

		const errors = Object.keys(addresses || {}).map(key => {
			if (addresses[key] && addresses[key].error && typeof addresses[key].error === 'string') {
			    return addresses[key].error
            } else if (addresses[key] && addresses[key].error && addresses[key].error.city) {
			    return 'CITY_' + addresses[key].error.city
            }
		})

        const defaultAddressProp = {
            country: this.props.defaultCountry,
        };

		return (
			<div className="Waypoint">
				<div className="Waypoint-line">
					<div className="Waypoint-address">
						<AddressControl
							label="Город / населенный пункт / улица / дом"
							placeholder="Начните вводить, чтобы выбрать"
							error={this.props.errorMessage}
							address={addresses[0] || defaultAddressProp}
							countries={this.props.countries}
							presetLocation={this.props.presetLocation}
							onChange={this._onAddressChange.bind(this, 0)}
							onBlur={this._onAddressBlur}
							onMapSave={this.props.onMainMapSave.bind(this)}
							highlightInput={this.props.highlightMainInput}
                            defaultCountry={this.props.defaultCountry}/>
					</div>
				</div>

				<AnimakitExpander expanded={showAdditionalAddress} duration={200}>
					<div className='Waypoint-line'>
						<div className="Waypoint-additionalAddress">
							<AddressControl
								label="Город / населенный пункт / улица / дом"
								placeholder="Начните вводить, чтобы выбрать"
								error={errors[1]}
								address={addresses[1] || defaultAddressProp}
								countries={this.props.countries}
								presetLocation={this.props.presetLocation}
								onChange={this._onAddressChange.bind(this, 1)}
								show={this.state.showAdditionalAddress}
								onMapSave={this.props.onAdditionalMapSave.bind(this)}
                                defaultCountry={this.props.defaultCountry}/>
						</div>

						<div className="Waypoint-remove"
							onClick={this._removeAdditionalAddress}>
								Удалить
						</div>
					</div>
				</AnimakitExpander>

				<AnimakitExpander expanded={showAddNewAddressButton} duration={200}>
					<ButtonControl className={buttonClassNames}
						view="crystal"
						onClick={this._addAdditionalAddress}>
						+ {t('ADD_NEW_ADDRESS')}
					</ButtonControl>
				</AnimakitExpander>
			</div>
		);
	}
}

export default Waypoint;



// WEBPACK FOOTER //
// ./client/components/Waypoint/Waypoint.js